// Utilidades para trabajar las categorias (lista plana con `parent_id`) como un arbol.

// Devuelve las categorias en orden de arbol (cada padre seguido de sus hijas, alfabetico por nivel),
// agregando `depth` (0 = principal) y `path` ("Padre › Hija").
export function flattenCategoryTree(categories) {
  const ids = new Set(categories.map((category) => category.id));
  const childrenByParent = new Map();

  categories.forEach((category) => {
    // Si el padre no existe en la lista, se trata como categoria principal.
    const parentKey = category.parent_id && ids.has(category.parent_id) ? category.parent_id : null;
    if (!childrenByParent.has(parentKey)) {
      childrenByParent.set(parentKey, []);
    }
    childrenByParent.get(parentKey).push(category);
  });

  childrenByParent.forEach((children) => children.sort((a, b) => a.name.localeCompare(b.name, 'es')));

  const result = [];
  const visited = new Set();

  const walk = (parentKey, depth, parentPath) => {
    (childrenByParent.get(parentKey) || []).forEach((category) => {
      if (visited.has(category.id)) {
        return; // protege contra ciclos en los datos
      }
      visited.add(category.id);
      const path = parentPath ? `${parentPath} › ${category.name}` : category.name;
      const childCount = (childrenByParent.get(category.id) || []).length;
      result.push({ ...category, depth, path, childCount });
      walk(category.id, depth + 1, path);
    });
  };

  walk(null, 0, '');

  return result;
}

// Ids de todas las subcategorias (a cualquier nivel) de la categoria indicada.
export function getDescendantIds(categories, categoryId) {
  const descendants = new Set();
  const pending = [categoryId];

  while (pending.length) {
    const currentId = pending.pop();
    categories.forEach((category) => {
      if (category.parent_id === currentId && !descendants.has(category.id)) {
        descendants.add(category.id);
        pending.push(category.id);
      }
    });
  }

  return descendants;
}

// Estilo de sangria para mostrar el nivel de una categoria dentro de un MenuItem.
export const categoryIndentSx = (depth) => ({ pl: 2 + depth * 2.5, fontWeight: depth === 0 ? 600 : 400 });
